import { KEYS_SLIDE_2, CUSTOM_KEYS_SLIDE_2, CATEGORIES_SLIDE_2 as CATS } from '../../constants';
import { SHARED_STATE } from './shared';

const SpanOfControlSlideState = {
    slideIndex: 2, // custom property
    identify_shape_name: 'checkme',
    identify_shape_value: 'Span_of_control_overview',
    data: [
        {
            name: 'checkme',
            is_delete: 'true',
        },
        {
            name: 'sub_title',
            existing_value: '~XX',
            value: '75',
        },
        {
            name: 'chart_1',
            type: 'chart',
            sub_type: 'bar',
            chart_data: [],
        },
    ],
};

// eslint-disable-next-line
export const generateSpans2PPT = async (data, clientName, addWithMainState) => {
    let slideState = {
        ...SpanOfControlSlideState,
    };
    // categories map
    const _CAT = {
        [CATS.TOO_MANY]: 'Managing Too Many',
        [CATS.IN_RANGE]: 'Managing In Range',
        [CATS.TOO_FEW]: 'Managing Too Few',
        [CATS.UNKNOWN]: 'Unknown',
    };
    // from bottom to top series value (for final json)
    // too_many series (3)
    // in_range series (2)
    // too_few  series (1)
    // unknown  series (0)
    const dataByCategories = data.series;
    const valuesByCategories = {
        [CATS.UNKNOWN]: [],
        [CATS.TOO_FEW]: [],
        [CATS.IN_RANGE]: [],
        [CATS.TOO_MANY]:[],
    };
    const spanBarSeriesMap = {
        [CATS.UNKNOWN]: 0,
        [CATS.TOO_FEW]: 1,
        [CATS.IN_RANGE]: 2,
        [CATS.TOO_MANY]: 3,
      };
    const chartData = []; // for json
    const placeHolderData = [];

    valuesByCategories[CATS.TOO_FEW] = dataByCategories.filter(e => e.name === _CAT[CATS.TOO_FEW])[0].data;
    valuesByCategories[CATS.IN_RANGE] = dataByCategories.filter(e => e.name === _CAT[CATS.IN_RANGE])[0].data;
    valuesByCategories[CATS.TOO_MANY] = dataByCategories.filter(e => e.name === _CAT[CATS.TOO_MANY])[0].data;
    valuesByCategories[CATS.UNKNOWN] = dataByCategories.filter(e => e.name === _CAT[CATS.UNKNOWN])[0].data;

    const tooFewSum = valuesByCategories[CATS.TOO_FEW].reduce((acc, curr) => (acc += curr), 0);
    const inRangeSum = valuesByCategories[CATS.IN_RANGE].reduce((acc, curr) => (acc += curr), 0);
    const tooManySum = valuesByCategories[CATS.TOO_MANY].reduce((acc, curr) => (acc += curr), 0);
    const unknownSum = valuesByCategories[CATS.UNKNOWN].reduce((acc, curr) => (acc += curr), 0);

    let maxReporteeSpan =  -Infinity;
    for (let i = 0; i < valuesByCategories[CATS.TOO_FEW].length; i++) {
        let sum = 0;
        for(const span of dataByCategories) {
            sum += span.data[i];
        }
        maxReporteeSpan = Math.max(maxReporteeSpan, sum)
    }

    // using this only to access the index
    let SUM_OF_FIRST_COL = 0;
    let SUM_OF_FIRST_TWO_COLS = 0;
    const TOTAL_SUM = tooFewSum + inRangeSum + tooManySum + unknownSum;

    const SUM_COL_MAP = {};
    const spanKeys = Object.keys(valuesByCategories);

    // considering "too_few" randomly as all categories will have same length
    for (let i = 0; i < valuesByCategories[CATS.TOO_FEW].length; i++) {
        // at every index level check the same indexes for each category data array
        // from there decide the value of the "series" for each node
        // eslint-disable-next-line
        let sum = 0; // sum of each values in column (index wise)
        for (const [columnIndex, key] of spanKeys.entries()) {
            if (valuesByCategories.hasOwnProperty(key)) {
                const value = valuesByCategories[key][i];
                chartData.push({
                    index: i,
                    row_index: i + 1,
                    column_index: columnIndex + 1,
                    series: spanBarSeriesMap[key],
                    value: value,
                    label: value || ''
                });
                sum += value;
            }
        } // end of key loop

        chartData.push({
            index: i,
            column_index: spanKeys.length + 1,
            row_index: i + 1,
            series: Object.keys(spanBarSeriesMap).length,
            value: maxReporteeSpan / 10,
            label: sum || '',
          });
      
        if (!sum) {
        placeHolderData.push({
            name: `zero_placeholder_${i + 1}`,
            value: 0,
            hidden: false,
        });
        }

        //  map of sum of values on each each column
        SUM_COL_MAP[i] = sum;

        // accumulating the sum of first two columns elements
        if (i < 2) {
            SUM_OF_FIRST_TWO_COLS += sum;
        }
        // accumulating the sum of first column elements
        if (i < 1) {
            SUM_OF_FIRST_COL += sum;
        }
    } // end of for loop

    // this denotes the percentage of people managers have 4 or less direct reports
    // ie. sum of values on the first two bars and its percent on total
    const firstTwoColsPercentage = ((SUM_OF_FIRST_TWO_COLS / TOTAL_SUM) * 100 || 0).toFixed(0);
    const firstColPercentage = ((SUM_OF_FIRST_COL / TOTAL_SUM) * 100 || 0).toFixed(0);

    slideState = {
        ...slideState,
        data: slideState.data.map(d => {
            if (d.name === 'chart_1') {
                return { ...d, unhide_zero: true, chart_data: chartData, meta_data: { min_bound: 0, max_bound: maxReporteeSpan } };
            }
            return d;
        }),
    };

    slideState = {
        ...slideState,
        data: [
            ...slideState.data,
            {
                name: KEYS_SLIDE_2[CUSTOM_KEYS_SLIDE_2.applied_filters_comment].name,
                value: SHARED_STATE.FILTER_STRING,
            },
            {
                name: KEYS_SLIDE_2[CUSTOM_KEYS_SLIDE_2.company_name_comment].name,
                existing_value: KEYS_SLIDE_2[CUSTOM_KEYS_SLIDE_2.company_name_comment].existing_value,
                value: clientName,
            },
            {
                name: KEYS_SLIDE_2[CUSTOM_KEYS_SLIDE_2.percentage].name,
                existing_value: KEYS_SLIDE_2[CUSTOM_KEYS_SLIDE_2.percentage].existing_value,
                value: firstTwoColsPercentage,
            },
            {
                name: KEYS_SLIDE_2[CUSTOM_KEYS_SLIDE_2.percentage_comment].name,
                existing_value: KEYS_SLIDE_2[CUSTOM_KEYS_SLIDE_2.percentage_comment].existing_value,
                value: firstColPercentage,
            },
            ...placeHolderData,
        ],
    };
    addWithMainState(slideState);
};
